// Vendor
import React, { Component } from 'react';
import Head from 'next/head';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Router from 'next/router';
// Root Styles
import '../../styles/document.styl';
// Components
import ErrorHandler from 'components/ErrorHandler';
import Header from 'components/Header';
import Footer from 'components/Footer';
import PageLoader from 'components/PageLoader';
// Styles
import './style.styl';

const formatTitle = title => {
  const siteName = 'BezTZ.net';
  if (title) {
    return `${title} - ${siteName}`;
  }
  return siteName;
};

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routeChanging: false,
    };
  }

  componentDidMount() {
    Router.router.events.on('routeChangeStart', this.routeChangingStart);
    Router.router.events.on('routeChangeComplete', this.routeChangingEnd);
  }
  componentWillUnmount() {
    Router.router.events.off('routeChangeStart', this.routeChangingStart);
    Router.router.events.off('routeChangeComplete', this.routeChangingEnd);
  }

  routeChangingStart = () => {
    this.setState({ routeChanging: true });
  };
  routeChangingEnd = () => {
    this.setState({ routeChanging: false });
    // Скрол при смене url
    window.scrollTo(0, 0);
  };

  render() {
    const {
      className,
      children,
      user,
      title,
      showHeader,
      showFooter,
      transparentFooter,
      httpStatus,
      metaTags,
      router,
      currentHost,
    } = this.props;
    const { routeChanging } = this.state;

    const metaTitle = formatTitle(metaTags.title);
    const metaDescription = formatTitle(metaTags.description);
    const metaImage = metaTags.image
      ? metaTags.image
      : `https://${currentHost}/static/images/teaser.jpg`;
    return (
      <div className={cn('Layout', className)}>
        <Head>
          <title>{metaTitle}</title>
          <meta property="og:title" content={metaTitle} />
          <meta property="og:description" content={metaDescription} />
          <meta property="og:image" content={metaImage} />
          <meta property="og:image:secure_url" content={metaImage} />
        </Head>

        <PageLoader in={routeChanging} />

        {showHeader && <Header user={user} router={router} />}

        <main className="Layout__content">
          {httpStatus ? <ErrorHandler statusCode={httpStatus}>{children}</ErrorHandler> : children}
        </main>

        {showFooter && <Footer transparent={transparentFooter} />}
      </div>
    );
  }
}

Layout.defaultProps = {
  className: '',
  title: '',
  showHeader: true,
  showFooter: true,
  navCategory: 'individuals',
  metaTags: {
    description: 'Обмен продуктовым опытом с профессиональным сообществом',
    title: 'Без ТЗ',
    image: null,
  },
};

Layout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  navCategory: PropTypes.string,
  title: PropTypes.string,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  // animated: PropTypes.bool,
  httpStatus: PropTypes.number,
};

export default withRouter(Layout);



// WEBPACK FOOTER //
// components/Layout/index.js